export var initialSelection = {
  start: 0,
  end: 0,
  text: ''
};